import { createSelector } from 'reselect';
import { createPrimarySelector } from '../../../utils/helpers';
import { RAG, Name, Postcode, Grade, Duration } from '../../../settings/constants/sorting';

export const selectSelectedDate = createPrimarySelector(state => state.areas.dailyPlanning.selectedDate);
export const selectSelectedTeam = createPrimarySelector(state => state.areas.dailyPlanning.filters.selectedTeam);
export const autoAllocateDate = createPrimarySelector(state => state.areas.dailyPlanning.autoAllocate.date);
export const autoAllocateOrgUnitId = createPrimarySelector(state => state.areas.dailyPlanning.autoAllocate.teamId);
export const selectCliniciansPostcodes = createPrimarySelector(
  state => state.entities.postings.general.clinicianBasePostcodes,
);

export const selectTreatmentInstanceSorting = createPrimarySelector(
  state => state.areas.dailyPlanning.treatmentInstanceSorting,
);

export const selectSchedulerMapView = createPrimarySelector(state => state.areas.dailyPlanning.schedulerMapView);
export const selectSchedulerIsNightMode = createPrimarySelector(
  state => state.areas.dailyPlanning.scheduler.isNightMode,
);

export const selectJwtToken = createPrimarySelector(state => state.global.auth.jwtToken);

export const selectPostcodeDistance = createPrimarySelector(
  state => state.entities.treatmentInstances.postcodeDistance,
);

export const selectTreatmentInstanceSortingIteratee = createSelector(
  selectTreatmentInstanceSorting,
  sorting => {
    if (!sorting) return null;
    switch (sorting.orderBy) {
      default:
      case RAG:
        return [
          i => i.ragStatus.value,
          i => i.patientFullName,
          i => (i.masterId ? i.masterId : i.treatmentInstanceId),
          i => i.isFirstChild,
          i => i.isLastChild,
        ];
      case Name:
        return [
          i => i.patientFullName,
          i => i.patientFullName,
          i => (i.masterId ? i.masterId : i.treatmentInstanceId),
          i => i.isFirstChild,
          i => i.isLastChild,
        ];
      case Postcode:
        return [
          i => i.address.postCode,
          i => i.patientFullName,
          i => (i.masterId ? i.masterId : i.treatmentInstanceId),
          i => i.isFirstChild,
          i => i.isLastChild,
        ];
      case Grade:
        return [
          i => i.highestGrade.equivalence,
          i => i.patientFullName,
          i => (i.masterId ? i.masterId : i.treatmentInstanceId),
          i => i.isFirstChild,
          i => i.isLastChild,
        ];
      case Duration:
        return [
          i => i.activitiesTotalDuration,
          i => i.patientFullName,
          i => (i.masterId ? i.masterId : i.treatmentInstanceId),
          i => i.isFirstChild,
          i => i.isLastChild,
        ];
    }
  },
);
export const selectCurrentPath = createPrimarySelector(state => state.router.location.pathname);
